import isEmpty from 'lodash/isEmpty';

export const TeaserBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}) => {
  let dataSaved = {
    ...data,
    [id]: value,
  };

  // Atualiza os campos quando trocar a fonte
  if (id === 'href' && !isEmpty(value)) {
    dataSaved = {
      ...dataSaved,
      title: value[0].Title || '',
      description: value[0].Description || '',
      preview_image: [],
      subtitle: value[0].subtitle || value[0].category_title || '',
      image_alt: value[0].alt || value[0].Title || '',
    };
  }

  // Atualiza o image_alt quando trocar a imagem de preview
  if (id === 'preview_image' && !isEmpty(dataSaved.preview_image?.[0])) {
    dataSaved = {
      ...dataSaved,
      image_alt: dataSaved.preview_image[0].alt || '',
    };
  }

  onChangeBlock(block, dataSaved);
};
